// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7087":"bcaee1ba","7565":"fbf0c235"}[chunkId] + ".chunk.css";
};